import React from 'react';
import AccountContainer from './AccountContainer';

const AccountView = () => {
  return (
    <>
      <AccountContainer />
    </>
  )
}

export default AccountView;